import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { AdminOrdersRequest } from "./api";
import { getAdminOrders } from "./slice";

export const useAdminOrders = () => {
  const state = useAppSelector((state) => state.adminOrders);
  const dispatch = useAppDispatch();

  const getAdminOrdersHandler = useCallback(
    (data?: AdminOrdersRequest) => dispatch(getAdminOrders({ data })),
    [dispatch]
  );

  return {
    state,
    getAdminOrders: getAdminOrdersHandler,
  };
};
